<section class="alert-message"
  [class]="type">
  <div class="alert-icon"
    role="none"
    aria-hidden="true">
    @if (type === 'error') {
    <i class="i-vi-error"></i>
    }
    @if (type === 'warning') {
    <i class="i-vi-warning"></i>
    }
    @if (type === 'info' || type === 'warning-info') {
    <i class="i-vi-info"></i>
    }
  </div>

  <div class="alert-content">
    @if (!isContentHtml) {
    <span class="alert-text"
      role="alert"
      [title]="contentTitle || content"
      [attr.aria-label]="contentTitle || content">
      {{ content }}
    </span>
    }
    @if (isContentHtml) {
    <span class="alert-text"
      role="alert"
      [title]="contentTitle || content"
      [attr.aria-label]="contentTitle || content"
      [innerHTML]="content">
    </span>
    }
    @if (linkText) {
    <vi-ui-link class="alert-link"
      [inline]="true"
      [size]="'12-16'"
      [highContrast]="true"
      [role]="isButton? 'button': 'link'"
      [href]="isButton? 'javascript:void(0)' : linkPath"
      [text]="linkText"
      (linkClicked)="onClick()"></vi-ui-link>
    }
  </div>
  @if (hasCloseButton) {
  <button type="button"
    class="alert-close-button"
    data-testid="alert-close-button"
    [attr.aria-label]="closeButtonTitle"
    [title]="closeButtonTitle"
    (viUiAccessibleClick)="onCloseClick()">
    <i class="i-vi-close-big"
      role="none"
      aria-hidden="true"></i>
  </button>
  }
</section>
